module.exports = __webpack_public_path__ + "img/hotel-icon.e4168aa0.svg";